import React from 'react';
import PropTypes from 'prop-types';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Typography from '@material-ui/core/Typography';
import { makeStyles, styled, withStyles } from '@material-ui/core/styles';
import StepConnector from '@material-ui/core/StepConnector';
import COLORS from 'utils/constants/colors';

const StyledStepLabel = styled(StepLabel)(({ theme }) => ({
  '& .MuiStepLabel-active': {
    color: theme.palette.secondary.light,
    fontSize: '14px !important',
  },
  '& .MuiStepLabel-label': {
    color: theme.palette.secondary.light,
    fontSize: '14px !important',
  },

  '& .MuiStepIcon-root.MuiStepIcon-completed': {
    color: theme.palette.primary.main,
  },

  '& .MuiStepIcon-root.MuiStepIcon-active': {
    color: theme.palette.primary.main,
  },
  '& .MuiStepIcon-root': {
    color: theme.palette.secondary.dark,
  },
}));

const TripConnector = withStyles(theme => ({
  active: {
    '& $line': {
      borderColor: theme.palette.primary.main,
    },
  },
  completed: {
    '& $line': {
      borderColor: theme.palette.primary.main,
    },
  },
  line: {
    borderColor: theme.palette.secondary.light,
    borderLeftStyle: 'dashed',
    borderRadius: 1,
    borderLeftWidth: 2,
  },
}))(StepConnector);

const useStyles = makeStyles(theme => ({
  root: {
    '&$active': {
      color: theme.palette.secondary.light,
    },
    '&$completed': {
      color: theme.palette.secondary.light,
    },
  },
  stepper: {
    backgroundColor: `${theme.palette.primary.light} !important`,
  },
  stepLabel: {
    color: COLORS.BLUE_04,
  },
  icon: {
    color: `${theme.palette.primary.main}!important'`,
  },
  active: {
    color: COLORS.GREEN,
  },
  selected: {
    color: COLORS.PINK,
  },
  completed: {
    color: theme.palette.text.primary,
  },
}));

const TripLocations = ({ value }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Stepper
        activeStep={0}
        orientation="vertical"
        connector={<TripConnector />}
        className={classes.stepper}
      >
        {value.map((location, index) => (
          <Step key={index}>
            <StyledStepLabel>{location.label}</StyledStepLabel>
            <StepContent>
              <Typography>{location.content}</Typography>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};
TripLocations.propTypes = {
  value: PropTypes.array,
};
export default TripLocations;
